var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculatorImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 243.799,
    height: 114.134,
    viewBox: "0 0 243.799 114.134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3208",
    "data-name": "Group 3208",
    transform: "translate(0 -43.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1330",
    "data-name": "Group 1330",
    transform: "translate(73.728 43.686)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M583.9,418.419l-5.966,70.939s-.625,4.3,2.573,4.307c5.26.013,26.177,0,26.177,0s-3.958-.895-3.91-2.909c.057-2.374,6.973-73.009,6.973-73.009Z",
    transform: "translate(-519.115 -379.71)",
    fill: "#779bdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M609.236,491.738c-1.034,0-21.013.065-26.134,0-2.232-.028-2.623-1.984-2.642-3.251a6.3,6.3,0,0,1,.068-1.056l.155-1.844.4-4.7.349-4.152.449-5.336.378-4.5,4.239-50.407,25.847-.671s-2.913,29.56-4.974,51.078c-.23,2.4-.449,4.7-.651,6.842q-.1,1.028-.19,2.007c-.191,2.036-.366,3.905-.517,5.556-.08.87-.154,1.679-.221,2.419-.263,2.9-.417,4.755-.419,5.107a3,3,0,0,0,.051.574C605.842,491.664,608.848,491.738,609.236,491.738Z",
    transform: "translate(-519.97 -379.069)",
    fill: "#aec3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M492.883,360.94l14.532,58.374,1.99,7.995,6.768,27.189H641.922L616.975,360.94Z",
    transform: "translate(-490.869 -360.832)",
    fill: "#aec3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M491.881,360.94l-2.014.671,22.628,94.917,2.678-2.031Z",
    transform: "translate(-489.866 -360.832)",
    fill: "#779bdd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M523.755,503.089H648.729l3.451-2.031H526.433Z",
    transform: "translate(-501.128 -407.393)",
    fill: "#779bdd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 27.059,
    height: 1.286,
    transform: "translate(93.574 113.983) rotate(180)",
    fill: "#aec3fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M606.973,504.1l-.14.983-25.448,5.141.349-4.152.166-1.972Z",
    transform: "translate(-520.278 -408.404)",
    fill: "#779bdd",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M609.237,525.531c-1.034,0-21.013.065-26.135,0-2.232-.028-2.623-1.984-2.642-3.251l25.327-4.765c-.263,2.9-.417,4.755-.419,5.107a2.993,2.993,0,0,0,.051.574C605.843,525.457,608.848,525.531,609.237,525.531Z",
    transform: "translate(-519.971 -412.862)",
    fill: "#94b0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M579.636,468.587,524.4,487.527l-6.769-27.189Z",
    transform: "translate(-499.092 -393.862)",
    fill: "#94b0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M492.883,360.94H616.974l19.982,75.191H511.609Z",
    transform: "translate(-490.869 -360.832)",
    fill: "#d1e0fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M637.025,436.077h-1.039l-8.507-32.458-10.935-41.725H494.427l18.5,74.183-1.321.014-18.721-75.2,124.521-.108.109.415,10.931,41.949Z",
    transform: "translate(-490.869 -360.779)",
    fill: "#94b0ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M704.2,457.884l-1,.134L694.464,424.7l.965-.476Z",
    transform: "translate(-557.854 -381.862)",
    fill: "#aec3fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332",
    transform: "translate(26.889 66.351)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M444.64,424.213c-.229-.69,3.126.9,7.124-.44,3.446-1.155.339-3.4,1.217-6.258.625-2.032.428-7.49-4.9-7.709a3.941,3.941,0,0,0-3.13-.161C440.746,411.042,432,425.21,444.64,424.213Z",
    transform: "translate(-429.551 -409.408)",
    fill: "#18365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M454.84,441.636a13.977,13.977,0,0,0,1.423,2.153c1.107,1.386,6.913-1.9,6.413-2.153s-3.418-8.656-4.113-9.712-3.063-1.6-3.063-1.6Z",
    transform: "translate(-433.914 -414.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M427.885,522.005s-1.6,1.463-1.29,2.5,1.759,1.733,1.955,3,.977,1.964,1.681,1.964h3.354s.518-.894-.733-1.164-1.722-1.761-1.645-3.147a24.405,24.405,0,0,0-.117-3.233l-2.658-.616Z",
    transform: "translate(-426.555 -438.523)",
    fill: "#21457d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M446.61,523.088s-.576,6.2.127,6.543l9-.019s0-1.039-1.446-1.27-3.988-1.078-4.418-2.964S446.61,523.088,446.61,523.088Z",
    transform: "translate(-431.715 -438.985)",
    fill: "#1d3253"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M437.305,437.284a35.929,35.929,0,0,0,0,4.161c.089,1.506,1.611,3.521,1.827,4.019.542,1.25,1.153,1.454,1.153,1.454l4.728,1.159,1.662.407,5.242-1.565s2.387-6.664,1.429-10.416a28.825,28.825,0,0,0-2.424-6.357,37.407,37.407,0,0,0-9.847-.356Z",
    transform: "translate(-429.337 -414.676)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M436.717,444.23c.09,1.5,2.062,3.468,2.278,3.966.542,1.25,1.153,1.454,1.153,1.454l4.728,1.159.854-2.447s-6.908-1.814-5.8-8.208Z",
    transform: "translate(-429.199 -417.408)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M453.568,454.357s2.6,8.081,2.763,10.832-4.963,39.083-5.168,40.351c-.195,1.195-1.679,1.957-1.679,1.957a2.244,2.244,0,0,1-1.656.127,4.1,4.1,0,0,1-1.779-.838s-2.02-25.911-.77-35.167a146.618,146.618,0,0,0,1.265-17.261Z",
    transform: "translate(-431.32 -421.103)",
    fill: "#243961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M438.464,454.032s-3.96,5.313-4.329,8.9-.579,16.209-1.366,19.71-3.676,10.239-3.676,21.16a2.18,2.18,0,0,0,1.228.96,10.236,10.236,0,0,0,1.079.3,1.7,1.7,0,0,0,1.9-.9c1.953-3.934,8.177-16.621,8.5-19.254.226-1.864,2.191-14.2,6.477-21.436,1.029-1.737-.632-8.648-.632-8.648Z",
    transform: "translate(-427.215 -421.018)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M452.976,452.671a5.435,5.435,0,0,1-3.112.866c-2.473.05-8.6-.63-8.6-.63a5.066,5.066,0,0,0-.261,1.564s7.484,1.888,11.82.275A2.739,2.739,0,0,0,452.976,452.671Z",
    transform: "translate(-430.314 -420.664)",
    fill: "#243961"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331",
    transform: "translate(19.015 32.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M452.257,454.547a1.137,1.137,0,1,1,1.128,1.277A1.211,1.211,0,0,1,452.257,454.547Zm.374,0a.767.767,0,1,0,.755-.9A.841.841,0,0,0,452.631,454.547Z",
    transform: "translate(-452.257 -453.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M446.474,455.288l11.249.105,5.535-13.008-11.249-.105Z",
    transform: "translate(-431.738 -417.961)",
    fill: "#a67cf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M448.462,451.193l.825-1.013a2.893,2.893,0,0,1,.962-.582c.406-.085,1.26-.578,1.343-.439s-.657,1.131-.657,1.131l-.037.005c.849.639,2.993.075,3.257.336.321.316-.441,1-.85,1.382a3,3,0,0,1-2.49.738c-.667-.207-1.716-.419-1.716-.419Z",
    transform: "translate(-432.255 -419.744)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M467.552,445.331s-.707-.8-1.157-.418.118,2.282.546,2.089S467.8,445.567,467.552,445.331Z",
    transform: "translate(-436.878 -418.619)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M439.064,429.838s-3.22.356-5.532,4.554c-1.822,3.311-4.938,9.415-3.762,11.139.516.758,5.463,3.451,15,1.911a2.887,2.887,0,0,0-.92-1.764s-8.03-2.578-8.016-3.091c.026-.97,1.085-1.808,5.57-6.294C442.628,435.073,439.064,429.838,439.064,429.838Z",
    transform: "translate(-427.324 -414.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M445.758,428.337c-.11-.148.032-.621.209-1.5a16.436,16.436,0,0,0,.426-3.421l.237.039,3.991.672s-.091,1.067-.094,2.072v.025c0,.873.236,2.192-.058,2.365C448.957,429.473,446.184,428.909,445.758,428.337Z",
    transform: "translate(-431.541 -413.052)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M450.942,424.139s-.08,1.5-.082,2.51c-2.233-.053-3.425-2.222-3.909-3.181Z",
    transform: "translate(-431.862 -413.066)",
    fill: "#e59360"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M451,423.555s-5.231-.745-4.717-4,.185-5.537,3.547-5.2,3.813,1.682,3.906,2.808S452.374,423.665,451,423.555Z",
    transform: "translate(-431.678 -410.688)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M451.7,414.459s-2.036,3.586-4.318,3.8-3.141-.524-3.141-.524a6.289,6.289,0,0,0,2.615-3.345S450.907,412.473,451.7,414.459Z",
    transform: "translate(-431.156 -410.488)",
    fill: "#18365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M453.774,414.948a3.277,3.277,0,0,1,1.31,1.406,5.323,5.323,0,0,1,.229,3.1s1.49-2.421.513-4.079C454.791,413.613,453.774,414.948,453.774,414.948Z",
    transform: "translate(-433.637 -410.723)",
    fill: "#18365f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M391.449,471.392l2.842-.32a.633.633,0,0,1,.6.286q.246.383.529.751a10.554,10.554,0,0,0,1.125,1.256.627.627,0,0,1,.155.688l-1.09,2.783a.615.615,0,0,0,.3.779l2.449,1.213a.608.608,0,0,0,.779-.215l1.48-2.32a.609.609,0,0,1,.682-.264,11.058,11.058,0,0,0,3.467.346.628.628,0,0,1,.63.437l.5,1.6a.636.636,0,0,0,.723.429l2.66-.538a.534.534,0,0,0,.153-.051.609.609,0,0,0,.34-.623l-.237-2.123-.058-.517a11.094,11.094,0,0,0,2.8-2.253.61.61,0,0,1,.681-.164l2.241.88a.632.632,0,0,0,.8-.309l.928-1.872.264-.537a.64.64,0,0,0-.227-.825l-1.938-1.239a.609.609,0,0,1-.273-.664,10.993,10.993,0,0,0,.3-2.327,1.949,1.949,0,0,0,.006-.2.335.335,0,0,1,0-.067.624.624,0,0,1,.439-.534l2.592-.821a.484.484,0,0,0,.084-.033.633.633,0,0,0,.342-.687l-.532-2.652a.63.63,0,0,0-.688-.5l-2.964.335a.61.61,0,0,1-.612-.321,11.154,11.154,0,0,0-.929-1.42q-.28-.364-.582-.7a.643.643,0,0,1-.122-.666l1.047-2.676a.614.614,0,0,0-.3-.774l-2.424-1.2a.642.642,0,0,0-.827.229l-1.172,1.836a.631.631,0,0,1-.733.26,11.057,11.057,0,0,0-3.344-.6.625.625,0,0,1-.59-.44l-.738-2.336a.648.648,0,0,0-.741-.438l-2.643.529a.62.62,0,0,0-.495.678l.013.124.277,2.467a.632.632,0,0,1-.342.635l0,0a10.924,10.924,0,0,0-1.639,1.042c-.28.214-.543.44-.8.676a.621.621,0,0,1-.653.127l-2.275-.894a.642.642,0,0,0-.811.311l-1.193,2.414a.669.669,0,0,0-.061.212.64.64,0,0,0,.286.6l1.55.985a.638.638,0,0,1,.29.556.681.681,0,0,1-.032.174,10.98,10.98,0,0,0-.559,4.306.619.619,0,0,1-.331.593.7.7,0,0,1-.1.04l-2.1.663a.628.628,0,0,0-.427.721l.012.061.516,2.586A.641.641,0,0,0,391.449,471.392Zm18.183-8.071a7.292,7.292,0,0,1,.386,1.312,5.779,5.779,0,0,1-.411,3.12c-.043.088-.087.173-.132.259a5.967,5.967,0,0,1-11.057-4.41,3.9,3.9,0,0,1,.218-.536,6.789,6.789,0,0,1,1.357-1.867A5.924,5.924,0,0,1,409.632,463.321Z",
    transform: "translate(-390.21 -352.947)",
    fill: "#d4dffa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M478.533,335.312l2.392-.269a.534.534,0,0,1,.5.24q.208.323.445.632a9.043,9.043,0,0,0,.948,1.058.525.525,0,0,1,.129.579l-.917,2.343a.518.518,0,0,0,.255.656l2.061,1.021a.512.512,0,0,0,.655-.182l1.247-1.952a.514.514,0,0,1,.574-.223,9.3,9.3,0,0,0,2.918.291.53.53,0,0,1,.53.368l.422,1.344a.534.534,0,0,0,.608.361l2.238-.452a.468.468,0,0,0,.129-.043.513.513,0,0,0,.286-.525l-.2-1.787-.05-.435a9.32,9.32,0,0,0,2.359-1.9.512.512,0,0,1,.573-.138l1.887.741a.532.532,0,0,0,.671-.26l.781-1.576.223-.452a.539.539,0,0,0-.192-.694l-1.631-1.042a.512.512,0,0,1-.229-.559,9.283,9.283,0,0,0,.249-1.959,1.588,1.588,0,0,0,0-.166.351.351,0,0,1,0-.056.525.525,0,0,1,.37-.449l2.182-.691a.388.388,0,0,0,.072-.028.535.535,0,0,0,.288-.579l-.448-2.232a.531.531,0,0,0-.579-.422l-2.495.282a.514.514,0,0,1-.516-.27,9.415,9.415,0,0,0-.78-1.195q-.235-.306-.491-.587a.54.54,0,0,1-.1-.56l.881-2.252a.516.516,0,0,0-.252-.652l-2.04-1.007a.541.541,0,0,0-.7.193l-.986,1.546a.531.531,0,0,1-.617.218,9.285,9.285,0,0,0-2.814-.506.526.526,0,0,1-.5-.371l-.621-1.966a.546.546,0,0,0-.624-.368l-2.224.445a.521.521,0,0,0-.417.57l.011.105.232,2.076a.533.533,0,0,1-.288.536h0a9.232,9.232,0,0,0-1.38.877c-.236.18-.457.371-.672.569a.524.524,0,0,1-.55.107l-1.915-.752a.54.54,0,0,0-.682.263l-1,2.032a.572.572,0,0,0-.052.178.538.538,0,0,0,.241.5l1.305.829a.539.539,0,0,1,.243.468.6.6,0,0,1-.027.147,9.233,9.233,0,0,0-.47,3.625.513.513,0,0,1-.363.533l-1.767.558a.53.53,0,0,0-.359.607l.01.052.434,2.177A.539.539,0,0,0,478.533,335.312Zm15.3-6.793a6.208,6.208,0,0,1,.325,1.105,4.854,4.854,0,0,1-.346,2.626c-.035.074-.073.146-.111.217a5.022,5.022,0,0,1-9.307-3.711,3.275,3.275,0,0,1,.183-.452,5.718,5.718,0,0,1,1.142-1.571A4.987,4.987,0,0,1,493.837,328.519Z",
    transform: "translate(-474.438 -270.928)",
    fill: "#d4dffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1339",
    "data-name": "Group 1339",
    transform: "translate(66.34 47.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M610.4,374.729v68.9a4.441,4.441,0,0,1-4.311,4.56h-121.9a4.441,4.441,0,0,1-4.311-4.56v-68.9a4.441,4.441,0,0,1,4.311-4.561h121.9A4.441,4.441,0,0,1,610.4,374.729Z",
    transform: "translate(-479.88 -370.168)",
    fill: "#8c9ef0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M610.4,374.479v3.158H479.88v-3.158a4.311,4.311,0,0,1,4.311-4.311h121.9A4.311,4.311,0,0,1,610.4,374.479Z",
    transform: "translate(-479.88 -370.168)",
    fill: "#6a81de"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1333",
    "data-name": "Group 1333",
    transform: "translate(15.176 12.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M554.363,419.319c2.037,2.609-.4,6.624,1,9.61.268.571.67,1.078.894,1.667a22.218,22.218,0,0,1,.447,3.079c.229,1.015,1.151,2.059,2.171,1.788.884-.235,1.239-1.3,1.214-2.2a8.414,8.414,0,0,1-.015-2.684,2.87,2.87,0,0,1,2.5-1.871,4.334,4.334,0,0,1,3.067,1.057c.935.77,1.959,1.927,3.106,1.518,1.1-.391,1.188-1.952.65-2.973s-1.476-1.822-1.875-2.9a4.649,4.649,0,0,1,.776-4.109,23.864,23.864,0,0,1,2.978-3.188,2.3,2.3,0,0,0,.766-1.246c.06-.491-.332-1.058-.83-.993-.336.044-.57.336-.829.55-1.121.931-2.98.385-3.833-.79a6,6,0,0,1-.778-4.164c1.753.409,3.342-2.008,5.035-1.4,1.061.382,1.353,1.68,1.635,2.756.5,1.914,1.458,3.716,1.707,5.677.475,3.74-1.622,7.848.248,11.138a7.978,7.978,0,0,0,3.127,2.844c2.973,1.677,6.762,2.329,9.837.84a21.88,21.88,0,0,0,6.938-5.983c.348-3.005-.1-4.831.44-5.762,2.042-3.506,8.126-.915,11.06-.741,8.1.484,7.632-4.745,7.605-7.164-.064-5.845-1.2-6.916-7.092-7.645-3.085-.382-6.265.241-9.3-.421-2.659-.58-5-2.1-7.538-3.062a19.039,19.039,0,0,0-14.6.538,11.832,11.832,0,0,1-3,1.178,2.84,2.84,0,0,1-2.871-1.023c-.678-1.074-.158-2.492.57-3.533a9.222,9.222,0,0,0,1.922-3.247,4,4,0,0,0-2.549-4.174,7.452,7.452,0,0,0-5.228.078c-3.081,1.045-5.619,3.226-7.9,5.512-2.708,2.709-5.3,5.894-5.679,9.675-.149,1.488.057,3.026-.464,4.461-.389,1.072-1.346,1.878-.972,3.07C549.425,417.366,552.986,417.556,554.363,419.319Z",
    transform: "translate(-518.265 -390.114)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M628.077,402.943l1.606,1.251a2.922,2.922,0,0,0,1.153.655c.849.156,1.629-.87,1.585-2.085s-.9-2.356-1.745-2.32c-.521.023-1.047.417-1.536.073-1.022-.719-1.714-4.2-2.609-1.848A3.882,3.882,0,0,0,628.077,402.943Z",
    transform: "translate(-544.502 -392.145)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M523.215,411.007l3.365,2.138c.623.395,1.335,1.03,1.075,1.712-.323.85-1.582.59-2.5.712a2.329,2.329,0,0,0-1.9,2.738c.222.9.96,1.953.287,2.6-.608.585-1.679.036-2.461.365-.463.2-.754.674-1.218.868-.4.165-.872.1-1.249.307-.468.257-.631.842-1.021,1.2-1.182,1.1-3.308-.492-4.693.344-1.055.638-.878,2.294-.054,3.2a13.445,13.445,0,0,0,3.093,2c1.047.652,2.014,1.758,1.786,2.956-.235,1.239-1.688,2.32-1.168,3.472a4.188,4.188,0,0,0,.737.905,3.033,3.033,0,0,1,.532,2.84,3.812,3.812,0,0,1-1.963,2.2c-.58.287-1.218.442-1.8.728-1.573.772-2.515,2.372-3.348,3.894a19.1,19.1,0,0,0-2.4,5.962c-.115.7-.224,1.528-.855,1.875a1.624,1.624,0,0,1-2.051-.949,12.745,12.745,0,0,1-.548-2.438c-.382-1.526-1.514-2.789-1.91-4.311-.948-3.642,2.53-7.26,1.868-10.962-.138-.772-.454-1.508-.576-2.283a4.742,4.742,0,0,1,1.537-4.217c1.27-1.117,3.23-1.688,3.738-3.287.562-1.765-1.071-3.585-.786-5.412.091-.585.376-1.129.459-1.715a4.789,4.789,0,0,0-.278-2.009c-.545-1.839-1.206-3.894-.291-5.585a5.652,5.652,0,0,1,2.653-2.2,15.488,15.488,0,0,1,7.929-1.416c1.14.092,2.2-.228,2.351,1.041A2.951,2.951,0,0,0,523.215,411.007Z",
    transform: "translate(-502.791 -395.295)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M542.251,395.474a21.057,21.057,0,0,1,1.97-1,2.27,2.27,0,0,0,1.3-1.654,1.886,1.886,0,0,0-.69-1.5,5.009,5.009,0,0,0-1.5-.837,26.168,26.168,0,0,0-3.217-1.066,3.289,3.289,0,0,0-1.847-.095,3.193,3.193,0,0,0-1.3,1,5.132,5.132,0,0,0-1.208,1.919,4.8,4.8,0,0,0,.452,3.168c.356.825,2.567,5.215,3.7,4.724.445-.193.609-2.094.789-2.549A4.509,4.509,0,0,1,542.251,395.474Z",
    transform: "translate(-513.886 -389.231)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M637.877,454.619a32.773,32.773,0,0,1,3.064-1.549,3.533,3.533,0,0,0,2.029-2.573,2.94,2.94,0,0,0-1.072-2.329,7.808,7.808,0,0,0-2.327-1.3,40.776,40.776,0,0,0-5-1.658,5.114,5.114,0,0,0-2.873-.148,4.968,4.968,0,0,0-2.018,1.553,7.982,7.982,0,0,0-1.88,2.985,7.467,7.467,0,0,0,.7,4.928c.554,1.283,3.993,8.112,5.761,7.348.692-.3.947-3.256,1.227-3.964A7.013,7.013,0,0,1,637.877,454.619Z",
    transform: "translate(-544.935 -408.029)",
    fill: "#c0d4fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    "data-name": "Group 1334",
    transform: "translate(5.108 3.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M487.592,375.986a.857.857,0,1,1,.856.856A.857.857,0,0,1,487.592,375.986Z",
    transform: "translate(-487.592 -375.129)",
    fill: "#eaf2f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 0.857,
    cy: 0.857,
    r: 0.857,
    transform: "translate(4.605 0)",
    fill: "#eaf2f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 0.857,
    cy: 0.857,
    r: 0.857,
    transform: "translate(9.21 0)",
    fill: "#eaf2f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1336",
    "data-name": "Group 1336",
    transform: "translate(44.06 20.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1335",
    "data-name": "Group 1335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M546.4,406.1c0,2.952,4.971,7.671,4.971,7.671s4.971-4.719,4.971-7.671a4.984,4.984,0,1,0-9.942,0Zm2.042-.313a2.929,2.929,0,1,1,2.929,2.929A2.934,2.934,0,0,1,548.441,405.79Z",
    transform: "translate(-546.399 -400.757)",
    fill: "#2cd3c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M549.482,406.862a2.929,2.929,0,1,1,2.929,2.929A2.929,2.929,0,0,1,549.482,406.862Z",
    transform: "translate(-547.44 -401.829)",
    fill: "#eaf2f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1338",
    "data-name": "Group 1338",
    transform: "translate(19.086 49.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1337",
    "data-name": "Group 1337"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M508.694,448.618c0,2.1,3.542,5.466,3.542,5.466s3.542-3.362,3.542-5.466a3.551,3.551,0,1,0-7.084,0Zm1.455-.223a2.087,2.087,0,1,1,2.087,2.087A2.091,2.091,0,0,1,510.149,448.394Z",
    transform: "translate(-508.694 -444.809)",
    fill: "#2cd3c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M510.89,449.158a2.087,2.087,0,1,1,2.087,2.087A2.087,2.087,0,0,1,510.89,449.158Z",
    transform: "translate(-509.435 -445.573)",
    fill: "#eaf2f9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(54.872 54.359)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 31.875,
    height: 32.675,
    rx: 15.938,
    fill: "#d4dffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340",
    transform: "translate(6.312 4.889)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1620",
    "data-name": "Path 1620",
    d: "M492.163,409.109a9.622,9.622,0,1,1-7.856-9.462c-1.2,4.378-2.8,10.177-2.9,10.539.2-.312,6.052-2.936,10.05-4.705A9.565,9.565,0,0,1,492.163,409.109Z",
    transform: "translate(-472.912 -398.722)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1621",
    "data-name": "Path 1621",
    d: "M495.335,404.163c-3.53,1.556-9.378,4.162-9.565,4.457.1-.344,1.719-6.224,2.8-10.165A10.576,10.576,0,0,1,495.335,404.163Z",
    transform: "translate(-476.257 -398.455)",
    fill: "#2cd3c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1346",
    "data-name": "Group 1346",
    transform: "translate(92.23 111.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 41.373,
    height: 38.176,
    rx: 19.088,
    fill: "#d4dffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(4.621 21.677)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1622",
    "data-name": "Path 1622",
    d: "M556.8,364.309H524.786V354.122H556.8Zm-31.621-.393h31.228v-9.4H525.179Z",
    transform: "translate(-524.786 -354.122)",
    fill: "#8c9ef0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(2.32 2.738)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 12.383,
    height: 0.807,
    fill: "#8c9ef0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 8.787,
    height: 0.807,
    transform: "translate(13.687)",
    fill: "#8c9ef0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 6.834,
    height: 0.807,
    transform: "translate(0 2.306)",
    fill: "#8c9ef0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 8.787,
    height: 0.807,
    transform: "translate(7.99 2.306)",
    fill: "#8c9ef0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 8.787,
    height: 0.807,
    transform: "translate(17.686 2.306)",
    fill: "#8c9ef0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    transform: "translate(4.817 3.773)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 3.339,
    height: 4.642,
    transform: "translate(0 10.153)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 3.339,
    height: 7.719,
    transform: "translate(5.719 7.076)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 3.339,
    height: 10.24,
    transform: "translate(11.438 4.555)",
    fill: "#2cd3c4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 3.339,
    height: 8.194,
    transform: "translate(17.158 6.601)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 3.339,
    height: 12.555,
    transform: "translate(22.877 2.24)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 3.339,
    height: 14.795,
    transform: "translate(28.596)",
    fill: "#2cd3c4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(192.994 59.849)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 50.806,
    height: 29.992,
    rx: 14.996,
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1349",
    "data-name": "Group 1349",
    transform: "translate(4.227 18.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1347",
    "data-name": "Group 1347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1623",
    "data-name": "Path 1623",
    d: "M675.573,430.543H656.788v-5.978h18.785Zm-18.554-.231h18.324V424.8H657.019Z",
    transform: "translate(-656.788 -424.565)",
    fill: "#c0d4fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1348",
    "data-name": "Group 1348",
    transform: "translate(1.361 1.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_325",
    "data-name": "Rectangle 325",
    width: 7.266,
    height: 0.474,
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 5.156,
    height: 0.474,
    transform: "translate(8.031)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_327",
    "data-name": "Rectangle 327",
    width: 4.01,
    height: 0.474,
    transform: "translate(0 1.353)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_328",
    "data-name": "Rectangle 328",
    width: 5.156,
    height: 0.474,
    transform: "translate(4.688 1.353)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_329",
    "data-name": "Rectangle 329",
    width: 5.156,
    height: 0.474,
    transform: "translate(10.378 1.353)",
    fill: "#c0d4fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1352",
    "data-name": "Group 1352",
    transform: "translate(26.626 18.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1350",
    "data-name": "Group 1350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1624",
    "data-name": "Path 1624",
    d: "M705.85,430.543H687.065v-5.978H705.85Zm-18.554-.231H705.62V424.8H687.3Z",
    transform: "translate(-687.065 -424.565)",
    fill: "#c0d4fc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1351",
    "data-name": "Group 1351",
    transform: "translate(1.361 1.606)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 7.266,
    height: 0.474,
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_331",
    "data-name": "Rectangle 331",
    width: 5.156,
    height: 0.474,
    transform: "translate(8.031)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_332",
    "data-name": "Rectangle 332",
    width: 4.01,
    height: 0.474,
    transform: "translate(0 1.353)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_333",
    "data-name": "Rectangle 333",
    width: 5.156,
    height: 0.474,
    transform: "translate(4.688 1.353)",
    fill: "#c0d4fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_334",
    "data-name": "Rectangle 334",
    width: 5.156,
    height: 0.474,
    transform: "translate(10.378 1.353)",
    fill: "#c0d4fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355",
    transform: "translate(4.227 12.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1354",
    "data-name": "Group 1354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1353",
    "data-name": "Group 1353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1625",
    "data-name": "Path 1625",
    d: "M699.14,420.152H656.788v-3.434H699.14Zm-41.95-.4h41.548V417.12H657.19Z",
    transform: "translate(-656.788 -416.718)",
    fill: "#c0d4fc"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_335",
    "data-name": "Rectangle 335",
    width: 32.874,
    height: 3.033,
    transform: "translate(0.201 0.201)",
    fill: "#c0d4fc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1358",
    "data-name": "Group 1358",
    transform: "translate(4.227 6.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1357",
    "data-name": "Group 1357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1356",
    "data-name": "Group 1356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1626",
    "data-name": "Path 1626",
    d: "M699.14,410.922H656.788v-3.434H699.14Zm-41.95-.4h41.548V407.89H657.19Z",
    transform: "translate(-656.788 -407.488)",
    fill: "#c0d4fc"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_336",
    "data-name": "Rectangle 336",
    width: 22.022,
    height: 3.434,
    transform: "translate(0 0)",
    fill: "#2cd3c4"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(140.028 51.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1627",
    "data-name": "Path 1627",
    d: "M579.482,397.438c0,4.884,8.223,12.689,8.223,12.689s8.224-7.806,8.224-12.689-3.682-8.843-8.224-8.843S579.482,392.555,579.482,397.438Zm3.377-.519a4.846,4.846,0,1,1,4.846,4.846A4.854,4.854,0,0,1,582.859,396.919Z",
    transform: "translate(-579.482 -388.595)",
    fill: "#2cd3c4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1628",
    "data-name": "Path 1628",
    d: "M584.047,398.143a4.846,4.846,0,1,1,4.846,4.846A4.846,4.846,0,0,1,584.047,398.143Z",
    transform: "translate(-580.67 -389.818)",
    fill: "#eaf2f9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(147.767 67.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1629",
    "data-name": "Path 1629",
    d: "M593.467,417.9a10.273,10.273,0,0,0-.786-3.04,4.139,4.139,0,0,0-2.675-1.258c-.394.382,1.165,1.733,1.227,2.231s-.792.153-.383,1.124a7.588,7.588,0,0,0,1.486,1.883Z",
    transform: "translate(-589.943 -410.773)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1630",
    "data-name": "Path 1630",
    d: "M593.115,418.882c.735-.576.892-.565.892-.565s6.8,5.888,7.457,6.411,10.868,3.485,10.868,3.485l1.622,8.3s-13.811-6.67-15.462-8.032c-2.727-2.249-6.168-8.545-6.168-8.545A2.6,2.6,0,0,1,593.115,418.882Z",
    transform: "translate(-590.562 -412.005)",
    fill: "#5353cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1631",
    "data-name": "Path 1631",
    d: "M616.768,526.447s-.118,2.836-.662,3.526l-7.575.044a1.186,1.186,0,0,1,1.132-1.152,5.081,5.081,0,0,0,3.68-2.9C614.186,524.121,616.768,526.447,616.768,526.447Z",
    transform: "translate(-594.779 -439.828)",
    fill: "#18365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1632",
    "data-name": "Path 1632",
    d: "M636.623,525.91s.528,3.767-.189,3.833c-.1.009-3.052.056-4.333.078-1.506.025-3.981-.027-3.981-.027a.394.394,0,0,1-.357-.593,1.589,1.589,0,0,1,1.138-.73c1.32-.254,3.518-1.223,4.289-2.986C634,523.63,636.623,525.91,636.623,525.91Z",
    transform: "translate(-599.769 -439.699)",
    fill: "#18365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1633",
    "data-name": "Path 1633",
    d: "M614.341,471.592s2.106,7.371,8.143,20.17,6.3,18.968,6.3,18.968a5.3,5.3,0,0,0,2.126.194,5.713,5.713,0,0,0,2.237-.725s-.391-15.234-3.243-21.694-3.432-24.134-3.432-24.134Z",
    transform: "translate(-596.29 -423.988)",
    fill: "#243961"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1634",
    "data-name": "Path 1634",
    d: "M609.769,465.56a183.8,183.8,0,0,0,1.807,25.426c1.975,14.013,1.051,20.53,1.051,20.53a3.939,3.939,0,0,0,2.134.374,4.786,4.786,0,0,0,2.85-.786s2.826-14.019,2.016-21.032S623.5,466,623.5,466Z",
    transform: "translate(-595.1 -424.297)",
    fill: "#2c5093"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1635",
    "data-name": "Path 1635",
    d: "M620.466,427.476l-2.231,1.652-3.223-.678c.044-.294.257-1.513.451-2.617.012-.065.023-.13.034-.194l.309-1.745,3.011-1.5,1.123-.559c0,.02-.087,1.042-.1,1.191A9.646,9.646,0,0,0,620.466,427.476Z",
    transform: "translate(-596.465 -412.92)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1636",
    "data-name": "Path 1636",
    d: "M625.344,457.24c-.729,3.336-16.339,1.872-16.135-.164.007-.068.048-1.011.1-2.281.118-2.748.3-7.042.322-7.378l0-.018c.281-2.835.55-5.609.568-7.42a25.81,25.81,0,0,1,.519-4.635c.266-1.346.592-2.568.875-3.52a3.9,3.9,0,0,1,2.28-2.5,3.361,3.361,0,0,1,.379-.132c1.836-.533,4.379-1.193,5.067-.991,1.866.549,3.252,3.835,4.234,8.021C625.4,444.06,625.821,455.066,625.344,457.24Z",
    transform: "translate(-594.955 -414.568)",
    fill: "#a67cf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M619.774,423.268c-.661,1.265-3.125,2.359-4.153,2.761.012-.065.023-.13.034-.194l.309-1.745,3.011-1.5C619.641,422.578,620.046,422.747,619.774,423.268Z",
    transform: "translate(-596.624 -413.117)",
    fill: "#f9a470"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1638",
    "data-name": "Path 1638",
    d: "M613.869,421.236s5.432,1.694,6.435-1.7,2.38-5.47-1.046-6.7-4.486-.129-5.1.925S612.482,420.707,613.869,421.236Z",
    transform: "translate(-595.991 -410.439)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1639",
    "data-name": "Path 1639",
    d: "M614.612,412.78s.346,3.956,1.165,3.784,1.56-.3,1.44.893-1.255,2.569,1.267,2.78,6.145-6.291,5.452-7.522C621.938,409.164,611.724,408.447,614.612,412.78Z",
    transform: "translate(-596.228 -409.786)",
    fill: "#18365f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1640",
    "data-name": "Path 1640",
    d: "M609.351,459.62c.118-2.748.3-7.042.322-7.377l0-.018,9.222-5.513S619.254,459.584,609.351,459.62Z",
    transform: "translate(-594.992 -419.393)",
    fill: "#8960ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1641",
    "data-name": "Path 1641",
    d: "M597.829,448.019a24.3,24.3,0,0,0-2.23-1.378,4.691,4.691,0,0,0-1.575-.138c-.054.092-.213.373-.01.468s.457.062.381.129-.843-.3-1.019.092-.332,1.73.567,2.135,3.118.039,3.277.086C598.578,449.807,597.829,448.019,597.829,448.019Z",
    transform: "translate(-590.801 -419.33)",
    fill: "#fcb180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1642",
    "data-name": "Path 1642",
    d: "M599.212,444.084s9.147,1.555,9.957,1.16c1.294-.63-.5-9.91-.5-9.91a2.67,2.67,0,0,1,2.38-2.6,5.914,5.914,0,0,1,4.195,1.168s1.873,1.676,1.634,3.536c-.53,4.122-1.355,12.5-4.112,13.788-3.555,1.657-13.843-4.6-13.843-4.6a1.794,1.794,0,0,1-.294-1.2A2.8,2.8,0,0,1,599.212,444.084Z",
    transform: "translate(-592.201 -415.737)",
    fill: "#5353cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1643",
    "data-name": "Path 1643",
    d: "M590.866,417.45s-.585-1.164-.679-1.382.135-.171.36-.05.533.8.88.716C591.7,416.669,590.866,417.45,590.866,417.45Z",
    transform: "translate(-590 -411.381)",
    fill: "#fcb180"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorImage);
export default __webpack_public_path__ + "static/media/calculatorImage.c280f09924f123d18ab4b731b844d0b9.svg";
export { ForwardRef as ReactComponent };